import { Box, Typography } from "@mui/material";
import { SearchBar } from "../SearchBar";
import { RenderToolbarProps } from "../TablePaginated/TablePaginated";
import { SessionFilterOption, StandardFilterOption, TableName, TableFilter } from "../TableFilter";
import { TableHeader } from "../TableHeader";

type Props<T extends SessionFilterOption | StandardFilterOption> = {
    title: string;
    subTitle?: string;
    onBack?: () => void;
    onFilter?: (option: T) => void;
    filterTableName?: TableName
    titleSize?: string
};

export type TableToolbarProps<T extends SessionFilterOption | StandardFilterOption> = Props<T> & RenderToolbarProps;

export default function TableToolbar<T extends SessionFilterOption | StandardFilterOption>({
    title,
    titleSize,
    subTitle,
    searchQuery,
    onBack,
    onSearch,
    onSearchClear,
    onFilter,
    filterTableName,
}: TableToolbarProps<T>) {
    return (
        <Box component="div" sx={{ display: "flex", backgroundColor: "#fff" }}>
            <TableHeader title={title}
                subtitle={subTitle}
                onBack={onBack}
                titleSize={titleSize}
                disableDivider />
            <SearchBar
                value={searchQuery}
                onChange={onSearch}
                clearSearch={onSearchClear}
            >
                {(onFilter && filterTableName) && <TableFilter tableName={filterTableName} defaultValue="ALL"
                    onChange={(option: any) => {
                        onFilter?.(option as T)
                    }}
                />}
            </SearchBar>
        </Box>
    );
}
